import React from "react"

interface Props extends React.ComponentPropsWithoutRef<"svg"> {
    size?: number | string
    style?: React.CSSProperties
    color?: string
    className?: string
}

export function LinkedInFarFAIcon({ size = 16, color, style, className, ...others }: Props) {
    return (
        <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="linkedin"
            className={`svg-inline--fa fa-linkedin fa-w-10 fa-fw ${className}`}
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 15 15"
            color={color}
            style={{ width: size, height: size, ...style }}
            {...others}
        >
            <path
                fill="currentColor"
                d="M14 1C14.5625 1 15 1.46875 15 2V14C15 14.5625 14.5625 15 14 15H2C1.4375 15 1 14.5625 1 14V2C1 1.46875 1.4375 1 2 1H14ZM5.21875 13H5.25V6.3125H3.15625V13H5.21875ZM4.1875 3C3.53125 3 3 3.53125 3 4.21875C3 4.875 3.53125 5.40625 4.1875 5.40625C4.84375 5.40625 5.40625 4.875 5.40625 4.21875C5.40625 3.53125 4.84375 3 4.1875 3ZM13 13V9.34375C13 7.53125 12.625 6.15625 10.5312 6.15625C9.5 6.15625 8.84375 6.71875 8.5625 7.21875H8.53125V6.3125H6.53125V13H8.625V9.6875C8.625 8.8125 8.78125 7.96875 9.84375 7.96875C10.9062 7.96875 10.9375 8.96875 10.9375 9.75V13H13Z"
            />
        </svg>
    )
}
